import type { Form } from 'factorial-form'

import FieldSet from 'modules/core/components/FieldSet'
import FormRow from 'modules/core/components/FormRow'
import Text from 'modules/core/components/Inputs/Text'
import Loading from 'modules/core/components/Loading'
import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import i18n from 'modules/core/lib/i18n'

import type AccessGroupForm from 'modules/surveys/components/AccessGroupForm'

import AccessGroupPicker from './AccessGroupPicker'
import Footer from './Footer'

interface Props {
  loading: boolean
  form: Form
  accessGroupForm: AccessGroupForm
  onSubmit: (closePortal: ClosePortalFn) => Promise<void>
  onClose: () => void
}

export default function NewSurveyModal({
  loading,
  form,
  accessGroupForm,
  onSubmit,
  onClose,
}: Props) {
  return (
    <Modal
      title={i18n.t('surveys.new.title')}
      description={i18n.t('surveys.new.description')}
      illustration="surveys"
      onClose={onClose}
      onSubmit={onSubmit}
      footer={<Footer loading={loading} form={accessGroupForm} name={form.get('name')} />}
    >
      {loading ? (
        <Loading />
      ) : (
        <>
          <FormRow>
            <Text
              mandatory
              label={i18n.t('surveys.new.form.labels.name')}
              field={form.get('name')}
            />
          </FormRow>
          <FormRow>
            <FieldSet
              title={i18n.t('surveys.new.form.participants.title')}
              description={i18n.t('surveys.new.form.participants.description')}
            >
              <AccessGroupPicker form={accessGroupForm} />
            </FieldSet>
          </FormRow>
        </>
      )}
    </Modal>
  )
}
